import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import { LoginProvider } from "../login/login";
import { AppConfig } from "../../config/app.config";

@Injectable()
export class AuthProvider {
    constructor(private login: LoginProvider,
        private http: Http,
        private config: AppConfig) {

    }

    /**
     * Authorized post
     * @param route To be appended to default url.
     * @param body To be sent.
     * @param headers Custom headers to append to default headers.
     * @param params Custom parameters to append to default parameters.
     */
    public async post(route: string, body: any, headers?: Headers, params?: URLSearchParams, appendStoreId = true): Promise<any> {
        return this.http.post(
            this.initUrl(route, appendStoreId),
            body,
            {
                headers: await this.initHeaders(headers),
                params: this.prepareParams(params),
                withCredentials: true
            }).map(res => res.json()).toPromise()
            .then(x => this.handleResponse(x, this.login))
            .catch(x => this.handleError(x, this.login));
    }

    /**
     * Authorized put
     * @param route To be appended to default url.
     * @param body To be sent.
     * @param headers Custom headers to append to default headers.
     * @param params Custom parameters to append to default parameters.
     */
    public async put(route: string, body: any, headers?: Headers, params?: URLSearchParams): Promise<any> {
        return this.http.put(
            this.initUrl(route),
            body,
            {
                headers: await this.initHeaders(headers),
                params: this.prepareParams(params),
                withCredentials: true
            }).map(res => res.json()).toPromise()
            .then(x => this.handleResponse(x, this.login))
            .catch(x => this.handleError(x, this.login));
    }

    /**
     * Authorized get
     * @param route To be appended to default url.
     * @param headers Custom headers to append to default headers.
     * @param params Custom parameters to append to default parameters.
     */
    public async get(route: string, headers?: Headers, params?: URLSearchParams): Promise<any> {
        return this.http.get(
            this.initUrl(route),
            {
                headers: await this.initHeaders(headers),
                params: this.prepareParams(params),
                withCredentials: true
            }).map(res => res.json()).toPromise()
            .then(x => this.handleResponse(x, this.login))
            .catch(x => this.handleError(x, this.login));
    }

    /**
     * Authorized delete
     * @param route To be appended to default url.
     * @param headers Custom headers to append to default headers.
     * @param params Custom parameters to append to default parameters.
     */
    public async delete(route: string, headers?: Headers, params?: URLSearchParams): Promise<any> {
        return this.http.delete(
            this.initUrl(route),
            {
                headers: await this.initHeaders(headers),
                params: this.prepareParams(params),
                withCredentials: true
            }).map(res => res.json()).toPromise()
            .then(x => this.handleResponse(x, this.login))
            .catch(x => this.handleError(x, this.login));
    }

    /**
     * Handles error reponses.
     * @param error Error of Request
     * @param login LoginProvider, because it does not exist in async context
     */
    private handleError(error, login) {
        console.log(error);
        if (error.status == 401) {
            console.log('Token expired!');
            login.logout();
        }
    }

    /**
     * Handles success responses.
     * @param response Response from request
     * @param login LoginProvider, beacause it does not exist in async context
     */
    private handleResponse(response, login): any {
        if (response.status == 401) {
            console.log('Token expired!');
            login.logout();
        }
        return response;
    }

    private initUrl(route?: string, appendStoreId = true): string {
        if (route && appendStoreId) {
            return this.config.domain + `/api/store/${this.config.companyId}/` + route;
        } else if (route && !appendStoreId) {
            return this.config.domain + `/api/` + route;
        } else {
            return this.config.domain + `/api/store/${this.config.companyId}/`;
        }
    }

    /**
     * Adds default headers.
     * @param headers Custom Headers
     */
    private async initHeaders(headers?: Headers): Promise<Headers> {
        return new HeadersBuilder(headers)
            .addAuth(await this.login.getToken())
            .build();
    }

    /**
     * Adds default params.
     * @param params Custom Params 
     */
    private prepareParams(params: URLSearchParams): URLSearchParams {
        if (!params) {
            params = new URLSearchParams();
        }
        return params;
    }
}

class HeadersBuilder {
    headers: Headers;

    constructor(headers?: Headers) {
        if (headers) {
            this.headers = headers;
        } else {
            this.headers = new Headers();
        }
    }

    /**
     * Adds the Authorization header to the headers.
     * @param token Value to be added to header
     */
    public addAuth(token: string): HeadersBuilder {
        if (token.length == 0) return this;
        this.headers.append("X-Authorization", token);
        return this;
    }

    /**
     * Sets content type in headers.
     * @param contentType Custom content type to be set
     */
    public addContentType(contentType?: string): HeadersBuilder {
        if (contentType) {
            this.headers.append("Content-Type", contentType);
        } else {
            this.headers.append("Content-Type", "application/json");
        }
        return this;
    }

    /**
     * Returns constructed headers.
     */
    public build() {
        return this.headers;
    }
}


// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts